// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  minAge: 17,
  apiURL: 'https://greybee.sapient.tools',
  languages: ['en', 'de'],
  cvLanguageEn: 'en',
  cvLanguageDe: 'de',
  greybeeConfig: {
    tenantId: 'a6f866c4-a8b8-4ab4-8651-531c922458f3',
    clientId: '7f874082-c2e9-4943-abd9-6c0479cbcdff',
    scope: 'greybee-skill-management',
    tenantName: 'greybee'
  },
  skillsConfig: {
    tenantId: 'd8c677d3-8dab-47a9-946e-bb03f14f2266',
    clientId: '55755dc3-819b-4e69-a13b-e3c512c57e36',
    scope: 'SkillDB-STAGE/SkillDB-STAGE',
    tenantName: 'skills'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
